var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#F1A33A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7182 12.8979H23.5603M23.5603 12.8979L20.2796 9.61719M23.5603 12.8979L20.2796 16.1786M20.2796 21.0996H10.4375M10.4375 21.0996L13.7182 24.3803M10.4375 21.0996L13.7182 17.8189",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch-icon.e42c5d63d649087a2d8fec9393061a31.svg";
export { ForwardRef as ReactComponent };